//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'SAMS_CI',
  data () {
    return {
      form: {
        data1: '',
        data2: '',
        data3: '',
        data4: ''
      },
      hasScore: false,
      disabled: false,
      dataList1: [
        {value: '1', name: '非特异性、不对称、间歇性疼痛'},
        {value: '2', name: '对称上肢近端疼痛或对称小腿疼痛'},
        {value: '3', name: '对称髋屈肌/大腿疼痛'}
      ],
      dataList2: [
        {value: '1', name: '治疗＞12周出现症状'},
        {value: '2', name: '治疗4~12周出现症状'},
        {value: '3', name: '治疗＜4周出现症状'}
      ],
      dataList3: [
        {value: '0', name: '停药后超过4周未改善'},
        {value: '1', name: '停药后2~4周内改善'},
        {value: '2', name: '停药后2周内改善'}
      ],
      dataList4: [
        {value: '1', name: '4~12周内再次出现相同症状'},
        {value: '3', name: '4周内再次出现相同症状'}
      ]
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad'])
  },
  computed: {
    /** 计算公式结果 */
    score () {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      let result = 0
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            form[key] = Number(form[key])
          }
        }
        result += Number(form[key])
      }
      if (!flag) {
        self.hasScore = false
        return ''
      } else {
        self.hasScore = true
        return String(result)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Card/SAMS_CI.vue